export function csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content ?? '';
}

export function apiHeaders(mutating = false) {
    const h = { 'Content-Type': 'application/json' };
    if (mutating) h['X-CSRF-Token'] = csrfToken();
    return h;
}

export function positionAcList(input, list) {
    const r = input.getBoundingClientRect();
    list.style.left = r.left + 'px';
    list.style.top = (r.bottom + 2) + 'px';
    list.style.width = r.width + 'px';
}
